import * as yup from 'yup';
import Config from '@config';

import http from '@/utils/http';

interface CodeValidationResult {
  isValid: boolean;
  isExists: boolean;
}

const INVALID_MESSAGE = 'Невірний формат';
const ALREADY_USED_MESSAGE = 'Вже використовується';

/**
 * Async uniqueness check of the shared organization edit form (`RbacOrganizationApiContext.validateCodeFn`) against
 * BMS's shared RBAC `GET /organizations/eic/validate` (GSB-8317), the only code that form checks. The http instance's
 * base is the app's own API (`/api`), so the request names BMS's base itself.
 */
export const validateOrganizationCodeFn = (
  key: 'eic',
  isStructurallyValid: (value: string) => boolean,
  excludeId?: string,
) =>
  async function (
    this: yup.TestContext,
    value?: string | null,
  ): Promise<boolean | yup.ValidationError> {
    if (!value || !isStructurallyValid(value)) return true;

    try {
      const params = new URLSearchParams({ [key]: value });
      if (excludeId) params.set('excludeId', excludeId);

      const { data } = await http<CodeValidationResult>({
        baseURL: Config.VITE_API_CLIENT_URL,
        url: `/organizations/${key}/validate?${params.toString()}`,
      });

      if (!data.isValid) return this.createError({ message: INVALID_MESSAGE });
      if (data.isExists)
        return this.createError({ message: ALREADY_USED_MESSAGE });
      return true;
    } catch {
      return false;
    }
  };
